import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { FormattedMessage, useIntl } from 'react-intl'
import * as routes from 'core/routing/constants/index'
import { Layout, Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import { isLight } from 'core/utils/colors'
import svg from 'assets/svg'
import { greys, font } from 'assets/themes/theme-default'
import configurationShape from '../../../configuration/shapes'

//import PreviewVehicle, { TYPE } from '../preview-vehicle'

const { Header } = Layout

const GlobalHeader = styled(Header)`
  z-index: 6;
  position: fixed;
  right: 0;
  left: 0;
  padding: ${isMobile ? '0 10px' : '0 100px'};
  height: ${isMobile && '50px'};
`

const StyledHeader = styled(GlobalHeader)`
  &&& {
    background: ${props => props.theme.colors.color2.bg};

    line-height: initial;
    & > div > div {
      :last-child {
        border-right-width: 0;
      }
    }
    & > .ant-layout-header > div > div:first-child {
      text-align: right;
    }
    a:focus {
      text-decoration: none;
    }
  }
`

const StyledHeaderPersonnal = styled(GlobalHeader)`
  &&& {
    background: ${props => props.background};
    border: 1px solid ${props => props.border};
    height: ${props => props.height}px;
  }
`

const StyledLogo = styled(SVG)`
  width: ${isMobile ? '150px' : '100%'};
  max-width: 230px;
  fill: ${props => props.theme.colors.color1.bg};
`
const StyledCol = styled(Col)`
  &&& {
    color: ${props => (isLight(props.theme.colors.color2.bg) ? greys.dark1 : greys.light4)};
    font-size: ${font.size.base};
    a {
      color: ${props => (isLight(props.theme.colors.color2.bg) ? greys.dark1 : greys.light4)};
      font-weight: ${font.weight.base};
    }
    &.logo {
      text-transform: uppercase;
      cursor: pointer;
      line-height: ${isMobile ? '12px' : '22px'};
      padding: 10px 0 0 0;
      font-size: ${font.size.base};
    }
  }
`
/*
const PointOfSalesWrapperRow = styled(Row)`
  height: 64px;
  font-weight: ${font.weight.bold};
`
const CityWrapper = styled.div`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
`
const MapIcon = styled(SVG)`
  width: 35px;
  height: 35px;
  fill: ${greys.light4};
`
*/

const HeaderApp = props => {
  const { configuration, setLayoutModalInfo } = props
  const intl = useIntl()
  const { campaign } = configuration

  useEffect(() => {
    if (campaign && campaign.name) {
      document.title = campaign.name
    } else {
      document.title = 'Global dealer'
    }
  }, [campaign])
  /*
   */

  useEffect(() => {
    if (campaign && campaign.theme.styleSheetPath) {
      const link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href = campaign.theme.styleSheetPath
      document.head.appendChild(link)
    }
    if (campaign && campaign.theme.faviconUrl) {
      const link2 = document.createElement('link')
      const oldLink = document.getElementById('favicon')
      link2.href = campaign.theme.faviconUrl
      link2.id = 'dynamic-favicon'
      link2.rel = 'shortcut icon'
      if (oldLink) {
        document.head.removeChild(oldLink)
        document.head.appendChild(link2)
      }
    }
  }, [campaign])

  function createHeader() {
    return { __html: campaign.theme.header.header.html }
  }

  function createMobileStyle() {
    return { __html: campaign.theme.header.header.mobile }
  }

  const showModalDeleteConfigurations = () => {
    const modalInfos = {
      showModal: true,
      title: intl.formatMessage({ id: 'global-modal-delete-vehicle-title' }),
      content: intl.formatMessage({ id: 'global-modal-delete-vehicle-content' }),
      route: `${routes.CONFIGURATION}?makeId=${props.tradeIn.makeId}&dealerCode=${props.tradeIn.dealerCode}`
    }

    setLayoutModalInfo(modalInfos)
  }

  // if (campaign && campaign.theme.styleSheetPath) {
  //   const link = document.createElement('link')
  //   link.type = 'text/css'
  //   link.rel = 'stylesheet'
  //   link.href = campaign.theme.styleSheetPath
  //   document.head.append(link)
  // }

  const config = localStorage.getItem('config')
  const isTheming = config === 'theming'
  return campaign && campaign.theme && campaign.theme.header && campaign.theme.header.header ? (
    <StyledHeaderPersonnal
      height={campaign.theme.header.header.height}
      background={campaign.theme.header.header.background}
      border={campaign.theme.header.header.border}
    >
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={createHeader()} />
      {isMobile && campaign.theme.header.header.mobile && (
        /* eslint-disable-next-line react/no-danger */
        <div dangerouslySetInnerHTML={createMobileStyle()} />
      )}
    </StyledHeaderPersonnal>
  ) : (
    <StyledHeader data-test="component-header">
      <Row type="flex">
        <StyledCol
          span={isMobile ? 12 : 5}
          className="logo"
          onClick={isTheming ? null : showModalDeleteConfigurations}
        >
          <StyledLogo svg={svg.logo} data-test="header-styled-logo" />
          <div>
            <FormattedMessage id="header-subtitleApp" />
          </div>
        </StyledCol>
      </Row>
    </StyledHeader>
  )
}
HeaderApp.defaultProps = {
  //vehicle: null,
  // tradeIn: null
}

HeaderApp.propTypes = {
  configuration: configurationShape.isRequired,
  setLayoutModalInfo: PropTypes.func.isRequired,
  // intl: PropTypes.shape().isRequired,
  tradeIn: PropTypes.shape()
  //wizards: wizardsShape.isRequired,
  //vehicle: PropTypes.shape(),
  // tradeIn: PropTypes.shape()
}

const mapStateToProps = state => ({
  tradeIn: state.tradeIn
})

/* eslint-disable-next-line react-redux/prefer-separate-component-file */
export default connect(mapStateToProps)(HeaderApp)

/*
<Col span={isMobile ? 6 : 7}>
            <Row type="flex" gutter={20}>
              {vehicle && (
                <Col span={12}>
                  <PreviewVehicle vehicle={vehicle} type={TYPE.NC} />
                </Col>
              )}
              {tradeIn && (
                <Col span={12}>
                  <PreviewVehicle vehicle={tradeIn} type={TYPE.UC} />
                </Col>
              )}
            </Row>
          </Col>

          <StyledCol span={6} data-test="header-point-of-sales">
            {pointOfSales && (
              <PointOfSalesWrapperRow type="flex" justify="end" align="middle" gutter={16}>
                <Col>
                  <MapIcon svg={svg.map_pin_inverted} />
                </Col>
                <Col data-test="header-point-of-sales-name">
                  {pointOfSales.name}
                  <CityWrapper data-test="header-point-of-sales-city">
                    {pointOfSales.city}
                  </CityWrapper>
                </Col>
              </PointOfSalesWrapperRow>
            )}
          </StyledCol>

*/
